import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';

import React, { forwardRef } from 'react';

import { useState } from 'react';

import { useEffect } from 'react';

import { useImperativeHandle } from 'react';

import JsonViewer from '../../JsonViewer';

const useStyles = makeStyles(() => ({
    jsonWrapper: {
        marginLeft: '15px',
        marginRight: '15px',
        position: 'relative',
    },
    textareaWrapper: {
        marginLeft: '15px',
        marginRight: '15px',
        position: 'relative',
        '& textarea': {
            width: '100%',
            minHeight: '500px',
            background: '#2f4f4f',
            color: '#d4d4d4',
            fontFamily: '"Consolas", "Monaco", "Courier New", monospace',
            fontSize: '13px',
            lineHeight: '1.5',
            border: '1px solid #e2e8f0',
            borderRadius: '4px',
            padding: '16px',
            resize: 'vertical',
            outline: 'none',
            '&:focus': {
                borderColor: '#267db7',
                boxShadow: '0 0 0 2px rgba(38, 125, 183, 0.2)',
            },
            '&::placeholder': {
                color: '#78909c',
            },
        },
    }
}));

const ResponseJsonContent = ({ 
    responseData, 
    tabInfo,
    isEditEnabled=false,
    customHeaderStyles = {
        boxShadow: 'inset 0rem 0rem 0.25rem rgb(0 0 0 / 8%)',
        overflowY: 'scroll',
    }
}, ref) => {
    const classes = useStyles();
    const [showCopySuccess, setShowCopySuccess] = useState(false);
    const [jsonData, setJSONData] = useState();
    useEffect(()=>{
        setJSONData(responseData?.edit_response_json || JSON.stringify(responseData?.response_json, null, 2));
    },[responseData])

    useImperativeHandle(ref,()=>{
        return {
            getJsonValue : ()=>{
                return jsonData;
            }
        }
    })

    const getFilename = () => {
        if (responseData?.fileName) return responseData.fileName;
        return `${tabInfo.dsarRequestId}_${responseData.app_name}_Response.json`;
    };

    return (
        <Box height={`calc(100% - 150px)`} sx={customHeaderStyles}>
            {!isEditEnabled ? (
                <Box className={classes.jsonWrapper}>
                    <JsonViewer 
                        data={responseData?.response_json || {}} 
                        filename={getFilename()}
                        containerStyle={{ 
                            maxHeight: 'calc(100vh - 300px)',
                            marginTop: '16px'
                        }}
                    />
                </Box>
            ) : (
                <Box className={classes.textareaWrapper}>
                    <textarea 
                        id="JSON"
                        rows="6"
                        placeholder="Enter valid Response JSON here..."
                        value={jsonData}
                        onChange={(e) => { setJSONData(e.target.value) }}
                    />
                </Box>
            )}
        </Box>
    )
}
export default React.memo(forwardRef(ResponseJsonContent));